import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import type { ListSectorsParams, SaveSectorRequest } from '../Types/Requests/SectorRequests'
import type { Sector, SectorSuggestionsResponse } from '../Types/Responses/SectorResponses'

export default class SectorService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/sectors'
  }

  async listByHealthUnit(healthUnitId: number, params: ListSectorsParams = {}): Promise<Sector[]> {
    try {
      const { data } = await request.get<Sector[]>(
        this.getCompletePath(`/healthUnit/${healthUnitId}`),
        params.includeArchived ? { includeArchived: 'true' } : undefined
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar os setores da unidade')
    }
  }

  async create(healthUnitId: number, body: SaveSectorRequest): Promise<Sector> {
    try {
      const { data } = await request.post<Sector>(
        this.getCompletePath(`/healthUnit/${healthUnitId}`),
        body
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível criar o setor')
    }
  }

  async update(sectorId: number, body: SaveSectorRequest): Promise<Sector> {
    try {
      const { data } = await request.patch<Sector>(this.getCompletePath(`/${sectorId}`), body)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível renomear o setor')
    }
  }

  async archive(sectorId: number): Promise<Sector> {
    try {
      const { data } = await request.post<Sector>(this.getCompletePath(`/${sectorId}/archive`), {})
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível arquivar o setor')
    }
  }

  async unarchive(sectorId: number): Promise<Sector> {
    try {
      const { data } = await request.post<Sector>(
        this.getCompletePath(`/${sectorId}/unarchive`),
        {}
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível reativar o setor')
    }
  }

  async remove(sectorId: number): Promise<void> {
    try {
      await request.delete(this.getCompletePath(`/${sectorId}`))
    } catch (e) {
      throw this.handleError(e, 'Não foi possível excluir o setor')
    }
  }

  async suggestions(): Promise<SectorSuggestionsResponse> {
    try {
      const { data } = await request.get<SectorSuggestionsResponse>(
        this.getCompletePath('/suggestions')
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as sugestões de setor')
    }
  }
}
